<section class="create-blog-wrapper" *ngIf="screenWidth > 475">
  <!-- Sticky Top Header Bar -->
  <div class="sticky-editor-header d-flex align-items-center justify-content-between">
    <!-- Left: Breadcrumb Back -->
    <div class="left-header d-flex align-items-center gap-2 cursor-pointer" (click)="confirmationFilter()">
      <mat-icon class="back-icon">keyboard_backspace</mat-icon>
      <span class="back-text">Back to Blogs</span>
    </div>

    <!-- Center: Integrated Tools Bar -->
    <div class="center-tools-bar d-flex align-items-center gap-2">
      <button type="button" class="tool-btn d-flex align-items-center gap-1" (click)="openBlogSettingsDialog($event)" title="Blog Settings">
        <mat-icon class="tool-icon">settings</mat-icon>
        <span>Settings</span>
      </button>

      <button type="button" class="tool-btn d-flex align-items-center gap-1" [cdkMenuTriggerFor]="analytics" title="Word & Reading Stats">
        <mat-icon class="tool-icon">bar_chart</mat-icon>
        <span>Stats</span>
      </button>

      <button type="button" class="tool-btn delete-btn d-flex align-items-center justify-content-center" (click)="deleteBlog()" *ngIf="blog.id" title="Delete Blog">
        <mat-icon class="tool-icon">delete_outline</mat-icon>
      </button>
    </div>

    <!-- Right: Action Buttons -->
    <div class="right-header d-flex align-items-center gap-2">
      <button type="button" (click)="goToAiWriter()" class="ai-btn cursor-pointer d-flex align-items-center gap-1">
        <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/801456c1763371563026ai.png" alt="AI Icon" class="ai-sparkle-img">
        <span>Write with AI</span>
      </button>

      <button type="button" class="save-btn d-flex align-items-center gap-1" [disabled]="isSavingDraft || isPublishing || screenLoading" (click)="saveToDraft()">
        <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <mat-icon *ngIf="!isSavingDraft" style="font-size: 15px; width: 15px; height: 15px; color: #475569;">save</mat-icon>
        <span>{{ isSavingDraft ? 'Saving Draft...' : 'Save Draft' }}</span>
      </button>

      <button type="button" class="publish-btn d-flex align-items-center gap-1" [disabled]="isPublishing || isSavingDraft || screenLoading" (click)="publishBlog()">
        <span *ngIf="isPublishing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <mat-icon *ngIf="!isPublishing" style="font-size: 15px; width: 15px; height: 15px; color: #ffffff !important;">publish</mat-icon>
        <span>{{ isPublishing ? 'Publishing...' : 'Publish' }}</span>
      </button>
    </div>
  </div>

  <!-- Scrollable Editor Workspace -->
  <div class="editor-workspace-scroll">
    <div class="editor-document-container mx-auto">
      <div class="editor-heading-prompt mb-3">Add Your Blog here...</div>
      <div #editor id="editorjs" class="editorjs-canvas" (keyup)="wordCounter($event)" #text></div>
    </div>
  </div>
</section>

<!-- Word Counter Analytics Popover -->
<ng-template #analytics>
  <div style="width: 280px;" class="stats-popover-card bg-white shadow-lg p-3 rounded-4 border" cdkMenu>
    <div class="d-flex align-items-center justify-content-between pb-2 border-bottom">
      <h4 class="m-0 font-weight-bold" style="font-size: 15px; color: #0f172a;">Article Analytics</h4>
      <mat-icon style="font-size: 18px; color: #64748b;">analytics</mat-icon>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-3" style="font-size: 13.5px;">
      <span class="text-secondary">Reading Time</span>
      <span class="text-dark font-weight-bold">{{ readTime }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2" style="font-size: 13.5px;">
      <span class="text-secondary">Word Count</span>
      <span class="text-dark font-weight-bold">{{ wordCount }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2" style="font-size: 13.5px;">
      <span class="text-secondary">Characters</span>
      <span class="text-dark font-weight-bold">{{ characterCount }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2" style="font-size: 13.5px;">
      <span class="text-secondary">Sentences</span>
      <span class="text-dark font-weight-bold">{{ sentenceCount }}</span>
    </div>
  </div>
</ng-template>

<!-- Mobile View Layout -->
<section class="create-blog-wrapper mobile-view" *ngIf="screenWidth < 475">
  <div class="sticky-editor-header d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
    <div class="left-header d-flex align-items-center gap-2 cursor-pointer" (click)="confirmationFilter()">
      <mat-icon>keyboard_backspace</mat-icon>
      <span class="back-text">Blogs</span>
    </div>
    <div class="d-flex align-items-center gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openBlogSettingsDialog($event)">
        <mat-icon style="font-size: 18px;">settings</mat-icon>
      </button>
      <button type="button" class="save-btn" (click)="saveToDraft()">Save</button>
      <button type="button" class="publish-btn" (click)="publishBlog()">Publish</button>
    </div>
  </div>

  <div class="editor-workspace-scroll p-3">
    <h3 class="mb-3">Add Your Blog here...</h3>
    <div #editor id="editorjs" class="editorjs-canvas" (keyup)="wordCounter($event)" #text></div>
  </div>
</section>
